/**
 * The mean of the dimension scores, as one number.
 *
 * A plain mean, because the dimensions carry equal weight by design — the same principle the risk
 * reference drawer states in prose. Dimensions the analysis could not score are **excluded rather than
 * counted as zero**: a rubric that could not be applied is not evidence of a weak posture, and averaging
 * it in as zero would let an unanswerable question drag the headline number down.
 *
 * Returns `undefined` when nothing is scorable, which the donut renders as an unknown ring rather than
 * as `0%` — those two things mean opposite things.
 *
 * The estate roll-up also means confidences and assumptions overhang with this, not a second copy of the
 * arithmetic: the same two rules apply to them — a value that could not be computed is not a zero, and
 * nothing to average is not an average of nothing.
 */
export const meanScore = (scores: number[]): number | undefined => {
  const scorable = scores.filter(score => Number.isFinite(score))
  if (scorable.length === 0) {
    return undefined
  }
  return scorable.reduce((total, score) => total + score, 0) / scorable.length
}
